// Core
import styled from 'styled-components';

// Plugins
import { BREAKPOINTS } from '../../../config/screen';

// Components
import { CardGrid } from '../../../layout/CardGrid';

export const LoadingContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Layout = styled.div`
  width: 100%;
  height: calc(100dvh - 64px);
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 2.75rem;
  };
`;

export const ResponsiveCardGrid = styled(CardGrid)`
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
`;

export const InputContainer = styled.div`
  padding: 1.25rem 0 0.75rem 0;
  justify-content: space-between;
`;

export const PageHeaderContainer = styled.div`
  margin-bottom: 1.5rem;
`;

export const CardCustomerContainer = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  padding-bottom: 4.375rem;
  justify-content: center;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    justify-content: flex-start;
  };
`;

export const NewCustomerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 1rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    flex-direction: row;
    gap: 0;
  };
`;

export const FilterCustomersContainer = styled.div`
  width: 100%;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    width: 50%;
  };

  @media (min-width: ${BREAKPOINTS.lg}px) {
    width: 25%;
  };
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
